import React from "react";
import { SectionHeading } from "./SectionHeading";
import { methodSteps } from "../data/landing";
export function MethodSection() {
  return <section className="bg-canvas" data-id="element-133" data-mp="7rqrcbuyizx4">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-24" data-id="element-134" data-mp="2u8rdayx3v19">
        <SectionHeading eyebrow="A Simple Way to Explore Big Questions" title={<>
              Help Your Child Think Through Faith in <span className="text-royal" data-id="element-136" data-mp="3v0dxh4y9y7wk">Four Simple Steps.</span>
            </>} subtitle={<p data-id="element-137" data-mp="vi4mib8u9evx">Practical, accessible, and designed for meaningful conversations at home.</p>} data-id="element-135" data-mp="2uigkwc51y5w" />

        <ol className="mt-14 grid gap-x-6 gap-y-10 md:grid-cols-2" data-id="element-138" data-mp="qkl4r1cxmjz8">
          {methodSteps.map(({
          step,
          icon: Icon,
          title,
          lines
        }) => <li key={step} className="relative rounded-3xl bg-white p-7 pt-10 shadow-[0_10px_30px_-18px_rgba(11,24,56,0.25)] md:p-8 md:pt-11" data-id="element-139" data-mp="hqg4xsftly7k">
              <span className="absolute -top-3.5 left-7 rounded-full bg-gold px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-wider text-navy" data-id="element-140" data-mp="1eb8gxytvrvrl">
                Step {step}
              </span>
              <span aria-hidden="true" className="absolute right-6 top-4 font-display text-6xl font-extrabold leading-none text-royal-light" data-id="element-141" data-mp="201bz9x0qv0ta">
                {step}
              </span>
              <Icon className="relative h-8 w-8 text-royal" strokeWidth={2} aria-hidden="true" data-id="element-142" data-mp="1lal8msaw27rr" />
              <h3 className="relative mt-4 font-display text-2xl font-extrabold text-ink" data-id="element-143" data-mp="1q95ybxsil91y">{title}</h3>
              <div className="mt-2 space-y-2 leading-relaxed text-ink-soft" data-id="element-144" data-mp="1ce3wpmupa5uy">
                {lines.map(line => <p key={line} data-id="element-145" data-mp="1h8hjx1z7l6oj">{line}</p>)}
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-xl font-bold leading-snug text-navy md:text-2xl" data-id="element-146" data-mp="12fo4thnumske">
          Faith becomes more than something children hear about. It becomes something they can begin to understand for
          themselves.
        </p>
      </div>
    </section>;
}